export default "__VITE_ASSET__1805cf3d__"